import { render, staticRenderFns } from "./BarStack.vue?vue&type=template&id=52c3cd3a&scoped=true&"
import script from "./BarStack.vue?vue&type=script&lang=js&"
export * from "./BarStack.vue?vue&type=script&lang=js&"
import style0 from "./BarStack.vue?vue&type=style&index=0&id=52c3cd3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3cd3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c3cd3a')) {
      api.createRecord('52c3cd3a', component.options)
    } else {
      api.reload('52c3cd3a', component.options)
    }
    module.hot.accept("./BarStack.vue?vue&type=template&id=52c3cd3a&scoped=true&", function () {
      api.rerender('52c3cd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BarStack.vue"
export default component.exports